import { ReportScheduleDialogComponent } from '../../../components/dialogs/report-schedule-dialog/report-schedule-dialog.component';
import { UsersDialogFormComponent } from '../../../components/dialogs/users/users-dialog-form.component';
import { MutationsComponent } from '../../../components/partials/mutations/mutations.component';
import { PaymentAccountsComponent } from '../../../components/partials/payment-accounts/payment-accounts.component';
import { ShareholderAccountsComponent } from '../../../components/partials/shareholder-accounts/shareholder-accounts.component';
import { SubReportsComponent } from '../../../components/partials/sub-reports/sub-reports.component';
import { TransactionsTableComponent } from '../../../components/partials/transactions-table/transactions-table.component';
import { CommandModel } from '../../../models/core/command.model';
import { DictionaryType } from '../../../models/types/dictionary.type';
import { ButtonMapper } from './button.mapper';

export class CommandMapper {
    static readonly commands: CommandModel[] = [
        // Shareholders
        new CommandModel({ name: 'GetShareholderCommand' }),
        new CommandModel({ name: 'CreateShareholderCommand', button: ButtonMapper.create }),
        new CommandModel({ name: 'ListShareholderAccountsCommand', component: ShareholderAccountsComponent }),
        new CommandModel({ name: 'ListPaymentAccountsCommand', component: PaymentAccountsComponent }),
        new CommandModel({ name: 'ListPaymentAccountsCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),
        new CommandModel({ name: 'ListShareholdersCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),
        new CommandModel({ name: 'ListTransactionsForShareholderCommand', component: TransactionsTableComponent }),
        new CommandModel({ name: 'ListTransactionsForShareholderCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),
        new CommandModel({ name: 'GetShareholderAccountCommand' }),
        new CommandModel({ name: 'GetTopNShareholdersCommand' }),
        new CommandModel({ name: 'UpdateShareholderCommand', button: ButtonMapper.update }),
        new CommandModel({ name: 'DeleteShareholderCommand', button: ButtonMapper.delete }),
        new CommandModel({ name: 'GetShareholderShareStatisticCommand' }),
        new CommandModel({ name: 'GetShareholderSummaryCommand' }),
        new CommandModel({ name: 'CreateOrUpdateNetvoteLoginCommand', button: ButtonMapper.createUpdateNetvote, isRequest: true }),
        new CommandModel({ name: 'CreateLoginForSharelogCommand', button: ButtonMapper.createUpdateNetvote, isRequest: true }),
        new CommandModel({ name: 'DeleteAllNetvoteUsersOnAirlockCommand', button: ButtonMapper.deleteUpdateNetvote, isRequest: true }),
        new CommandModel({ name: 'RebuildIndexesCommand', button: ButtonMapper.rebuildIndexes, isRequest: true }),

        // Favorites
        new CommandModel({ name: 'GetHasFavouriteCommand', isRequest: true }),
        new CommandModel({ name: 'CreateFavouriteCommand', button: ButtonMapper.addFavorite, isRequest: true }),
        new CommandModel({ name: 'DeleteFavouriteCommand', button: ButtonMapper.removeFavorite, isRequest: true }),

        // Mutations
        new CommandModel({
            name: 'ListMutationsCommand',
            button: ButtonMapper.changeHistory,
            component: MutationsComponent,
            showOnModal: true
        }),

        // Transactions
        new CommandModel({ name: 'ListTransactionsCommand', component: TransactionsTableComponent }),
        new CommandModel({ name: 'ListTransactionsCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),
        new CommandModel({ name: 'ApproveTransactionCommand', button: ButtonMapper.approveTransaction, isRequest: true }),

        // Traders
        new CommandModel({ name: 'CreateTraderCommand', button: ButtonMapper.create }),
        new CommandModel({ name: 'ListTradersCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),
        new CommandModel({ name: 'CleanTradersCommand', button: ButtonMapper.delete, isRequest: true }),
        new CommandModel({
            name: 'ListShareholderAccountsForTraderCommand',
            component: ShareholderAccountsComponent
        }), // shares component with Shareholder
        new CommandModel({ name: 'ListShareholderAccountsForTraderCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),
        new CommandModel({
            name: 'ListTransactionsForTraderCommand',
            component: TransactionsTableComponent
        }), // share component with Shareholder
        new CommandModel({ name: 'ListTransactionsForTraderCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),

        // Reports
        new CommandModel({ name: 'ListReportsCommand', component: SubReportsComponent }),
        new CommandModel({ name: 'CreateReportCommand', button: ButtonMapper.create }),
        new CommandModel({ name: 'UpdateReportCommand', button: ButtonMapper.update }),
        new CommandModel({ name: 'DeleteReportCommand', button: ButtonMapper.delete }),

        // Report Schedules
        new CommandModel({
            name: 'CreateReportScheduleCommand',
            button: ButtonMapper.createSchedule,
            component: ReportScheduleDialogComponent,
            showOnModal: true,
            modalWidth: '650px'
        }),
        new CommandModel({
            name: 'UpdateReportScheduleCommand',
            button: ButtonMapper.modifySchedule,
            component: ReportScheduleDialogComponent,
            showOnModal: true,
            modalWidth: '650px'
        }),

        // Users
        new CommandModel({ name: 'GetUserCommand' }),
        new CommandModel({
            name: 'CreateUserCommand',
            button: ButtonMapper.create,
            component: UsersDialogFormComponent,
            showOnModal: true
        }),
        new CommandModel({ name: 'ListUsersCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),
        new CommandModel({ name: 'UpdateUserCommand', button: ButtonMapper.update }),
        new CommandModel({ name: 'DeleteUserCommand', button: ButtonMapper.delete }),
        new CommandModel({ name: 'GetRegistrationQrCommand' }),
        new CommandModel({ name: 'GetUserSummaryCommand' }),

        // GM Shareholders
        new CommandModel({ name: 'ListGmShareholdersCsvCommand', button: ButtonMapper.exportCsv, isRequest: true }),
        new CommandModel({ name: 'UpdateGmShareholderRegisterCommand', button: ButtonMapper.registerSelf, isRequest: true }),
        new CommandModel({ name: 'CheckInGmShareholderCommand', button: ButtonMapper.checkIn, isRequest: true }),
        new CommandModel({ name: 'CheckOutGmShareholderCommand', button: ButtonMapper.checkOut, isRequest: true })
    ];

    static readonly tabs: DictionaryType<string> = {
        accounts: 'ListShareholderAccountsCommand',
        transactions: 'ListTransactionsCommand',
        reports: 'ListReportsCommand',
        'payment-accounts': 'ListPaymentAccountsCommand'
    };

    static readonly skipDefaultSubResourceBehavior = ['ListTransactionsForShareholderCommand', 'ListTransactionsCommand'];
}
